<template>
  <section class="hero is-fullheight terms-page">
    <PmNavbar />
    <div class="hero-body">
      <div class="container">
        <div class="columns is-multiline p-5">
          <div class="column is-12">
            <h2 class="mb-3 font-secondary">{{ this.$t("message.pages.termsPage.title") }}</h2>

            <h3 class="mt-5 font-secondary">{{ this.$t("message.pages.termsPage.h1") }}</h3>
            <p>
              {{ this.$t("message.pages.termsPage.p1_1") }}
            </p>
            <p class="mt-4">
                {{ this.$t("message.pages.termsPage.p1_2_1") }}
              <a href="mailto:asiakaspalvelu@packagemedia.fi">asiakaspalvelu@packagemedia.fi</a>
                {{ this.$t("message.pages.termsPage.p1_2_2") }}
            </p>
            <p class="mt-4">
              {{ this.$t("message.pages.termsPage.p1_3") }}
            </p>

            <h3 class="mt-5 font-secondary">{{ this.$t("message.pages.termsPage.h2_extra") }}</h3>
            <p>{{ this.$t("message.pages.termsPage.p2_1_extra") }}</p>

            <h3 class="mt-5 font-secondary">{{ this.$t("message.pages.termsPage.h2") }}</h3>
            <p>{{ this.$t("message.pages.termsPage.p2_1") }}</p>

            <h3 class="mt-5 font-secondary">{{ this.$t("message.pages.termsPage.h3") }}</h3>
            <p>
              {{ this.$t("message.pages.termsPage.p3_1") }}
            </p>
            <p class="mt-4">
              {{ this.$t("message.pages.termsPage.p3_2") }}
            </p>

            <h3 class="mt-5 font-secondary">{{ this.$t("message.pages.termsPage.h4") }}</h3>
            <p>
              {{ this.$t("message.pages.termsPage.p4_1") }}
            </p>

            <h3 class="mt-5 font-secondary">{{ this.$t("message.pages.termsPage.h9") }}</h3>
            <p>
              {{ this.$t("message.pages.termsPage.p9_1") }}
            </p>

            <p class="mt-3">
              {{ this.$t("message.pages.termsPage.p9_2") }}
            </p>

            <p class="mt-3">
              {{ this.$t("message.pages.termsPage.p9_3") }}
            </p>

            <p class="mt-3">
              {{ this.$t("message.pages.termsPage.p9_4") }}
            </p>

            <p class="mt-3">
              {{ this.$t("message.pages.termsPage.p9_5") }}
            </p>

            <p class="mt-3">
              {{ this.$t("message.pages.termsPage.p9_6") }}
            </p>

            <p class="mt-3">
              {{ this.$t("message.pages.termsPage.p9_7") }}
            </p>

            <h3 class="mt-5 font-secondary">{{ this.$t("message.pages.termsPage.h5") }}</h3>
            <p>
              {{ this.$t("message.pages.termsPage.p5_1") }}
            </p>
            <p class="mt-4">
              {{ this.$t("message.pages.termsPage.p5_2") }}
            </p>
            <p class="mt-4">
              {{ this.$t("message.pages.termsPage.p5_3") }}
            </p>

            <h3 class="mt-5 font-secondary">{{ this.$t("message.pages.termsPage.h6") }}</h3>
            <p>
              {{ this.$t("message.pages.termsPage.p6_1") }} <a href="mailto:asiakaspalvelu@packagemedia.fi">asiakaspalvelu@packagemedia.fi</a> {{ this.$t("message.pages.termsPage.p6_2") }}
            </p>

            <h3 class="mt-5 font-secondary">{{ this.$t("message.pages.termsPage.h8") }}</h3>
            <p>
              {{ this.$t("message.pages.termsPage.p8_1") }}
            </p>             
          </div>
        </div>
         
      </div>
    </div>
    <PmFooter />
  </section>  
</template>

<script>
import PmNavbar from "../components/PmNavbar";
import PmFooter from "../components/PmFooter";

export default {
  name: "TermsPage",
  components: {
    PmNavbar,
    PmFooter,
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {},
  computed: {},
}
</script>
